import Constants from '@/Constants';
import { resolveLocale } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import { updatePushNotificationStatusRequest } from '@/store/pushNotification/action';
import { PushNotification } from '@/store/pushNotification/types';
import { formatDistanceToNowStrict } from 'date-fns';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import './style.scss';

interface Props {
    notification: PushNotification;
}

const NotificationCard: React.FC<Props> = (props: Props) => {
    const { notification } = props;

    const { strings } = useSelector((state: ApplicationState) => ({ strings: state.locale.data }));

    const dispatch = useDispatch();
    const location = useLocation();

    const readNotification = () => {
        const btnNotification = document.getElementById('btn-notifications');
        btnNotification && btnNotification.click();

        if (!notification.checked) {
            dispatch(updatePushNotificationStatusRequest(notification.id));
        }
    };

    const navigateTo = (entityType: string): string => {
        switch (entityType) {
            case 'COURSES':
                return `/${Constants.COURSES_RESOURCE_NAME}/${notification.dynamicAttributes.entityId}`;
            case 'CONTENTS':
                return `/${Constants.CONTENTS_RESOURCE_NAME}/${notification.dynamicAttributes.entityId}`;
            case 'PERSON':
                return `/${Constants.PUBLIC_PROFILE_RESOURCE_NAME.replace('%p', notification.dynamicAttributes.entityId.toString())}`;
            default:
                return location.pathname;
        }
    };

    const getFormattedDate = (dateInMillis: number): string =>
        formatDistanceToNowStrict(new Date(dateInMillis), { addSuffix: true, locale: resolveLocale(strings._LANGUAGE) });

    return (
        <div className="notificationContainer">
            <NavLink
                className="notification"
                draggable={false}
                exact
                onClick={() => {
                    readNotification();
                }}
                to={navigateTo(notification.dynamicAttributes.entityType)}
            >
                <span className={`title ${notification.checked ? 'readNotification' : ''}`} title={notification.title}>
                    {notification.title}
                </span>
                <span className="message" title={notification.message}>
                    {notification.message}
                </span>
                <span className="date">{getFormattedDate(notification.creationDate)}</span>
            </NavLink>
            <div>
                <div className={'moreOptions'}></div>
                {/* <i className="material-icons-outlined align-middle moreOptions">{Constants.icons.MORE_HORIZ}</i> */}
            </div>
        </div>
    );
};

export default NotificationCard;
